import React, { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import _ from "lodash"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Box, Typography, Avatar, Grid } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	root: {
		marginBottom: 10,
		backgroundColor: theme.palette.grey[50],
		border: "none",
		"& .MuiButtonBase-root": {
			textTransform: "capitalize",
			fontSize: theme.typography.caption.fontSize,
		},
		"& .MuiCardHeader-root": {
			paddingBottom: 8,
		},
		"& .MuiCardContent-root": {
			paddingTop: 0,
			paddingBottom: 12,
		},
		"& .MuiCardActions-root > .MuiButtonBase-root": {
			backgroundColor: theme.palette.grey[100],
		},
	},
	summaryBox: {
		height: "38vh",
		overflowY: "auto",
		marginBottom: 20,
	},
}))

function AiSummary(props) {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [summary, setSummary] = useState("")
	const theme = useTheme()
	const [t] = useTranslation("global")

	useEffect(() => {
		setSummary((prev) => props?.metadata?.summary?.text)
	}, [props?.metadata])

	return (
		<Fragment>
			<Box className={classes.summaryBox}>
				{summary?.length > 0 ? (
					<Typography variant="body2" component="p">
						{summary}
					</Typography>
				) : (
					<Typography variant="body2" component="p">
						{t("viewer.tabs.summary.noSummary")}
					</Typography>
				)}
			</Box>
		</Fragment>
	)
}

export default AiSummary
